import React from 'react';
import type { TraceTimelineProps } from './types';

export const TraceTimeline: React.FC<TraceTimelineProps> = ({
  timelineTicks,
  showTimeline = true,
}) => {
  if (!showTimeline) {
    return null;
  }

  return (
    <div className="absolute top-0 left-0 right-0 h-[28px] bg-gray-50 border-b border-gray-200 flex items-center z-10">
      {timelineTicks.map((tick, index) => (
        <div
          key={index}
          className="absolute h-full flex flex-col justify-center"
          style={{ left: `${tick.position}%` }}
        >
          <div className="w-px h-3 bg-gray-300" />
          <div className="text-xs text-gray-600 mt-1 transform -translate-x-1/2">
            {tick.label}
          </div>
        </div>
      ))}
    </div>
  );
};
